import * as Sentry from "@sentry/react";

const isDevelopment = process.env.TROX_ENVIRONMENT === "development";
const isStaging = process.env.TROX_ENVIRONMENT === "staging";
const isProduction = process.env.TROX_ENVIRONMENT === "production";
const isSentryEnabled = isDevelopment || isStaging || isProduction; // Enable Sentry in all environments for testing purposes. Adjust as needed.

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.TROX_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: isSentryEnabled,
});
